import React from "react";
import Cookies from "universal-cookie";
import '../../../App.css';
import { NavLink } from "react-router-dom";
import '../../../App.css';
import * as RiIcons from 'react-icons/ri';
import * as FaIcons from 'react-icons/fa'
import * as MdIcons from 'react-icons/md'


const cookies = new Cookies();
class SyndicateDashboard extends React.Component {
    render() {
        const removeCookie = () => {
            cookies.remove("token")
            cookies.remove("user-type")
            window.location.href = "/"
        }

        if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '2') {
            return (
                <div className="Doctor-dashboard-div" style={{color:'#834358',}}>
                    <div className="Doctor-dashboard-heading">
                        <div style={{fontSize:56}}>مرحباً بكَ د. احمد علي</div>
                        <h4>..يمكنك اختيار النافذة المناسبة لغايتك من الخيارات ادناه</h4>
                    </div>
                    <div className="Doctor-dashboard-options" >

                        {/* INSERT NEW DOCTOR */}
                        <NavLink className="Doctor-dashboard-option-card" to='/' style={{color:'#834358'}}>
                            <div style={{ width: '20%', textAlign: 'center' }}>
                                <MdIcons.MdEditNote size={120} />
                            </div>
                            <div style={{ width: '70%', textAlign: 'right' }}>
                                <h2>نافذة ادخال معلومات طبيب جديد</h2>
                                <h6>.يمكنك من هذه النافذة ادخال المعلومات المتعلقة بالطبيب من اجل ادراجه ضمن النظام</h6>
                            </div>
                            <div style={{ width: '20%' }}>
                                <RiIcons.RiArrowDropLeftLine size={100} />
                            </div>
                        </NavLink>

                        {/* VIEW ALL REGISTERED DOCTORS */}
                        <NavLink className="Doctor-dashboard-option-card" to='/' style={{color:'#834358'}}>
                            <div style={{ width: '20%', textAlign: 'center' }}>
                                <FaIcons.FaRegAddressCard size={90} />
                            </div>
                            <div style={{ width: '70%', textAlign: 'right' }}>
                                <h2>نافذة عرض الاطباء المسجلين</h2>
                                <h6>.يمكنك من هذه النافذة متابعة وعرض جميع معلومات الاطباء المسجلين في النظام</h6>
                            </div>
                            <div style={{ width: '20%' }}>
                                <RiIcons.RiArrowDropLeftLine size={100}/>
                            </div>
                        </NavLink>

                        {/* VIEW DOCTORS ON MAP */}
                        <NavLink className="Doctor-dashboard-option-card" to='/' style={{color:'#834358'}}>
                            <div style={{ width: '20%', textAlign: 'center' }}>
                                <FaIcons.FaMapMarkedAlt size={90} />
                            </div>
                            <div style={{ width: '70%', textAlign: 'right' }}>
                                <h2>نافذة عرض مواقع الاطباء على الخريطة</h2>
                                <h6>.يمكنك من هذه النافذة عرض الموقع الجغرافي ونبذة عن معلومات الطبيب المسجل</h6>
                            </div>
                            <div style={{ width: '20%' }}>
                                <RiIcons.RiArrowDropLeftLine size={100}/>
                            </div>
                        </NavLink>
                    </div>
                    <div onClick={()=>removeCookie()} className="Doctor-dashboard-footer">
                        <div style={{fontSize:16}}>تسجيل الخروج</div>
                    </div>
                </div>

            );
        } else {
            window.location.href = "/"
        }
    }
}


export default SyndicateDashboard;
